import { observer } from "mobx-react-lite";
import { ModuleBlock } from "../../ui/Block";
import { Body } from "../../ui/Body";
import { Box } from "../../ui/Box";
import { ModuleEditor } from "../../ui/editor/useModuleEditor";
import { EditorRender } from "../../ui/YooptaEditor";
import type InfoModuleModel from "./InfoModel";

export const InfoModuleUI = observer(
  ({ module }: { module: InfoModuleModel }) => {
    return (
      <Box>
        <ModuleEditor module={module} />
      </Box>
    );
  },
);

export const InfoModuleBlockUI = observer(
  ({ module }: { module: InfoModuleModel }) => {
    return (
      <ModuleBlock module={module}>
        {module.data.descriptionYooptaEditor ? (
          <EditorRender value={module.data.descriptionYooptaEditor} />
        ) : (
          <Body muted>No text added...</Body>
        )}
      </ModuleBlock>
    );
  },
);
